import { render, staticRenderFns } from "./AiHeader.vue?vue&type=template&id=c6436062&scoped=true&"
import script from "./AiHeader.vue?vue&type=script&lang=js&"
export * from "./AiHeader.vue?vue&type=script&lang=js&"
import style0 from "./AiHeader.vue?vue&type=style&index=0&id=c6436062&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6436062",
  null
  
)

export default component.exports